import { MultiDialerSubscription, jsonSafeToMultiDialerSubscription, TwilioBusinessProfile, TwilioRegulatoryBundleRule, jsonSafeToTwilioBusinessProfile, jsonSafeToTwilioRegulatoryBundleRule } from "./db";
import { jsonSafeValueToDate } from "./typing";


export enum PaymentSubscriptionOption {
  STANDARD = 'STANDARD',
  PARALLEL = 'PARALLEL'
}

export const PaymentSubscriptionOptionToPaymentLink: {
  [k in PaymentSubscriptionOption]: string
} = {
  [PaymentSubscriptionOption.STANDARD]: 'https://buy.stripe.com/6oE6oF7Oqf0Laju5nK',
  [PaymentSubscriptionOption.PARALLEL]: 'https://buy.stripe.com/5kA00h0lY5qb3V67vT',
}

export const SubscriptionTypeToHumanReadable: {
  [k in PaymentSubscriptionOption]: string
} = {
  [PaymentSubscriptionOption.STANDARD]: 'Standard',
  [PaymentSubscriptionOption.PARALLEL]: 'Parallel Dialer'
}

export const SubscriptionTypeToPriceInfo: {
  [k in PaymentSubscriptionOption]: string
} = {
  [PaymentSubscriptionOption.STANDARD]: '59.99',
  [PaymentSubscriptionOption.PARALLEL]: '149.99'
}

export type MultiDialerQuotaInfo = {
  subscription: MultiDialerSubscription
  dials_remaining: number
  period_end: Date
  international_credits_remaining: number
  minutes_remaining: number
}

export function jsonSafeToQuotaInfo(v: Record<string, any>): MultiDialerQuotaInfo {
  return {
    subscription: jsonSafeToMultiDialerSubscription(v.subscription),
    dials_remaining: v.dials_remaining,
    period_end: jsonSafeValueToDate(v.period_end),
    international_credits_remaining: v.international_credits_remaining,
    minutes_remaining: v.minutes_remaining
  }
}

export interface ParallelDialerQuotasUpdate {
  max_dials_per_month?: number
  max_dials_per_second?: number
  max_dials_at_once?: number
  max_phone_numbers_per_user?: number
  international_credits_per_month?: number
}

export type ParallelDialerAccessInfo = {
  subscriptions: MultiDialerSubscription[]
  profiles: TwilioBusinessProfile[]
  bundle_rules: TwilioRegulatoryBundleRule[]
  weekly_cost: Record<string, number>
  number_count: Record<string, number>
}

export function jsonSafeToParallelDialerAccessInfo(v: Record<string, any>): ParallelDialerAccessInfo {
  return {
    subscriptions: v.subscriptions.map(jsonSafeToMultiDialerSubscription),
    profiles: v.profiles.map(jsonSafeToTwilioBusinessProfile),
    bundle_rules: v.bundle_rules.map(jsonSafeToTwilioRegulatoryBundleRule),
    weekly_cost: v.weekly_cost,
    number_count: v.number_count,
  }
}
